import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  APP_URL,
  AUTH_ERR_MSG,
  CFCProps,
  Preferences,
  USERSROLE,
  UserTermsType,
  SCREEN_SIZE
} from 'types';
import {
  selectIsAuthenticated,
  selectScreenSize,
  selectRedirectPath
} from 'redux/session/selectors';
import { UnAuthenticatedPageLayout } from 'layouts/unAuthenticatedPage.layout';
import { RootState } from 'redux/root.reducer';
import { CustomRightHeaderPanel } from 'layouts/components';
import { Button, Checkbox, Link, Loading } from 'carbon-components-react';
import { ButtonContent } from 'components';
import { ArrowRight16 } from '@carbon/icons-react';
import { fetchTermsAcceptance } from 'redux/auth/action';
import ContactUs from 'components/ContactUs';
import Utils from 'utilities/helper.util';
import { isString } from 'lodash';
import { fetchUserStart } from 'redux/user/actions';
import DownloadLink from 'react-download-link';
import Service from 'services';
import { redirectResidentialEnquirerIfNeeded } from 'utilities/residential-redirect.util';
import { currentUser as selectCurrentUser } from 'redux/session/selectors';

export const UserTermsPanel: React.FC<Props> = (props) => {
  const PREF_INITIAL_SATE: Preferences = {
    isMarketingUpdatesAllowed: false,
    isNewslettersAllowed: false
  };
  const { loginType, userRole } = props.app;
  const { error, submitting }: any = props.login;
  const dispatch = useDispatch();
  const history = useHistory();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const currentUser = useSelector(selectCurrentUser);
  const screenSize = useSelector(selectScreenSize);
  const redirectPath = useSelector(selectRedirectPath);
  const [isForceAcceptance, setIsForceAcceptance] = useState<boolean>(false);
  const [userTerms, setUserTerms] = useState<UserTermsType>();
  const [preferences, setPreferences] = useState<Preferences>(
    PREF_INITIAL_SATE
  );
  // EFFECTS
  useEffect(() => {
    if (!error?.message) {
      dispatch(fetchUserStart());
    }
  }, [dispatch, error]);

  useEffect(() => {
    if (error) {
      const errorMessage = isString(error) ? error : error.message;
      errorMessage === AUTH_ERR_MSG.USER_SESSION_ORGANISATION &&
        history.push(APP_URL.AUTH_MULTI_ORGANISATION);
    }
    const renderLoginPage =
      (loginType === null && userRole === USERSROLE.OTHER) || false;
    const renderDashboradPage =
      (isAuthenticated && loginType !== null && !error) || false;

    //Redirect
    if (renderDashboradPage) {
      if (
        redirectResidentialEnquirerIfNeeded(userRole, currentUser, redirectPath)
      ) {
        return;
      }
      history.push(APP_URL.DASHBOARD);
    }
    renderLoginPage && history.push(APP_URL.LOGIN);
  }, [
    history,
    isAuthenticated,
    loginType,
    userRole,
    error,
    currentUser,
    redirectPath
  ]);

  useEffect(() => {
    error && setUserTerms(error.UserTerms);
  }, [error]);

  const finishSignInHandler = async () => {
    if (userTerms) {
      const userTermsId: number = userTerms.id;
      isForceAcceptance &&
        dispatch(fetchTermsAcceptance({ userTermsId, preferences }));
    }
  };
  const handleLogout = useCallback(async () => {
    await Service.auth.ssoLogout();
  }, []);

  return (
    <div id="terms" className="full-page--backgroud" data-testid="terms">
      <UnAuthenticatedPageLayout>
        {screenSize && screenSize !== SCREEN_SIZE.SM && (
          <div className="full-page--backgroud-image">
            {/*FULL BG-IMAGE HOLDER*/}
          </div>
        )}
        <CustomRightHeaderPanel
          className="--swx-theme--dark sso-terms"
          panelHeading="Terms"
          panelFooter={<ContactUs />}
          isExpanded={true}
          hideCloseButton={true}
          isModel={false}
        >
          {userTerms && !Utils.isObjectEmpty(userTerms) ? (
            <div className="sso-terms--wrapper">
              <h1 className="sso-terms--heading">
                Please accept the terms to continue
              </h1>
              <div className="sso-terms--body custom-scroller">
                {userTerms && (
                  <div
                    dangerouslySetInnerHTML={{ __html: userTerms.text }}
                  ></div>
                )}
              </div>
              <div className="sso-terms--accepts">
                <Checkbox
                  labelText="I accept"
                  id="accepts"
                  onChange={(val) => setIsForceAcceptance(val)}
                />
                <DownloadLink
                  label="Download terms"
                  filename="terms.html"
                  style={{}}
                  exportFile={() => userTerms.text}
                />
              </div>
              <div className="sso-terms--marketing">
                <Checkbox
                  labelText="Send me newsletters"
                  id="newsletters"
                  onChange={(val: boolean) =>
                    setPreferences({
                      ...preferences,
                      isNewslettersAllowed: val
                    })
                  }
                />
                <Checkbox
                  labelText="Send me marketing updates"
                  id="marketing"
                  onChange={(val: boolean) =>
                    setPreferences({
                      ...preferences,
                      isMarketingUpdatesAllowed: val
                    })
                  }
                />
                <Button
                  className="custom--btn-icon sso-terms--button"
                  type="submit"
                  kind={'tertiary'}
                  disabled={!isForceAcceptance}
                  data-testid="submit"
                  onClick={() => finishSignInHandler()}
                >
                  <ButtonContent isLoading={submitting} icon={<ArrowRight16 />}>
                    Finish sign-in
                  </ButtonContent>
                </Button>
                <Link
                  className="sso-terms--signOut"
                  onClick={() => handleLogout()}
                  area-label="Sign out"
                >
                  Sign out
                </Link>
              </div>
            </div>
          ) : (
            <Loading
              className="panelLoader"
              description="Active loading indicator"
              withOverlay={false}
            />
          )}
        </CustomRightHeaderPanel>
      </UnAuthenticatedPageLayout>
    </div>
  );
};

const mapStateToProps = ({ app, login }: RootState) => ({
  app,
  login
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

UserTermsPanel.displayName = 'UserTermsPanel';

export default connector(UserTermsPanel);
